<div class="list-wrapper">
  <div *ngIf="group">
  <form-control-model [defaultHeight]="25" [columns]="columns" [group]="group" [model]="model" (onRowsSelected)="onRowsSelected($event)">
    <div style="margin-top: 8px" class="fcContent">
      <st-lookup
        *ngIf="group"
        name="PayCompaniesIds"
        [group]="group"
        userClass="select-sm"
        label="شعبه بیمه"
        textFieldName="DisplayName"
        apiName="PayCompanies/GetPayCompaniesInsuranceBranchs"
        valueFieldName="PayCompaniesId"
        [defaultHeight]="25"
        [isPaging]="false"
        [isMulti]="true"
        [columns]="pcColumns"
        textColumnsName="PartyCode,DisplayName,WorkshopCode,CompanyName">
      </st-lookup>
    </div>
  </form-control-model>
</div>
<kgrid
  *ngIf="filterInfo && filterInfo.length > 0"
  [apiName]="apiName"
  [label]="label"
  [name]="apiName"
  [areaName]="areaName"
  pathPreFix="HRM"
  [isMulti]="true"
  [isAdd]="false"
  [isEdit]="false"
  [isDelete]="false"
  defaultSortKey="PersCode"
  defaultSortKeyKind="asc"
  [defaultFilterKey]="filterInfo"
  [actionTregger]="onActionClick"
  [actions]="actions">
</kgrid>
</div>

